import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { IIcon, IIconComponent, ITooltipDirective } from "@front/m19-ui";

export enum BulkUploadPreviewStatus {
  CREATION = "creation",
  UPDATE = "update",
  VALUE_ERROR = "value_error",
  UNCHANGED = "unchanged",
}

export enum BulkUploadRunStatus {
  CREATED = "created",
  UPDATED = "updated",
  FAILED = "failed",
}

interface IconConfig {
  icon: IIcon;
  classes: string;
}

@Component({
  selector: "app-bulk-upload-type-icon",
  imports: [IIconComponent, ITooltipDirective],
  template: `
    <div
      class="flex size-5 items-center justify-center rounded-md border"
      [class]="config().classes"
      [iTooltip]="tooltip()"
      iTooltipPlacement="top-center"
      iTooltipWidth="300"
    >
      <IIcon [name]="config().icon" />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadTypeIconComponent {
  type = input.required<BulkUploadPreviewStatus | BulkUploadRunStatus>();
  tooltip = input<string | undefined>(undefined);

  config = computed<IconConfig>(() => {
    switch (this.type()) {
      case BulkUploadPreviewStatus.CREATION:
        return { icon: "add", classes: "[&>IIcon]:text-green-400 border-green-200 bg-green-50" };
      case BulkUploadPreviewStatus.UPDATE:
        return { icon: "circleArrows", classes: "[&>IIcon]:text-blue-500 border-blue-200 bg-blue-50" };
      case BulkUploadPreviewStatus.VALUE_ERROR:
        return { icon: "alertTriangle", classes: "[&>IIcon]:text-orange-500 border-orange-200 bg-orange-50" };
      case BulkUploadPreviewStatus.UNCHANGED:
        return { icon: "minus", classes: "[&>IIcon]:text-gray-500 border-gray-200 bg-gray-50" };
      case BulkUploadRunStatus.CREATED:
        return { icon: "check", classes: "[&>IIcon]:text-green-400 border-green-200 bg-green-50" };
      case BulkUploadRunStatus.UPDATED:
        return { icon: "check", classes: "[&>IIcon]:text-blue-500 border-blue-200 bg-blue-50" };
      case BulkUploadRunStatus.FAILED:
        return { icon: "times", classes: "[&>IIcon]:text-red-500 border-red-200 bg-red-50" };
    }
  });
}
